// extracted by mini-css-extract-plugin
module.exports = {"testimonials":"Testimonials_testimonials__35AVd","testimonialText":"Testimonials_testimonialText__3CgOG","testimonialClient":"Testimonials_testimonialClient__2bUFj"};